import { GzMapWithBubblesChartWebComponent } from './component/GzMapWithBubblesChartWebComponent';

export { GzMapWithBubblesChartWebComponent };
